import React from 'react'
import { DonutChart } from '../'
import { CountMessagesSelector, } from '../SelectorStates/SelectorStates'
import './mainCard.css'

const MainCard = () => {

  return (
    <>
        <div className='card-header-box-wrapper'>
            {/* <a href="/posts" className='card-main'>
                <div>
                    <div className='card-numbers'>0</div>
                    <div className='card-names'>Posts</div>
                </div>
                <DonutChart />
            </a> */}
            <a href="/messages" className='card-main'>
                <div>
                    <div className='card-numbers'>{<CountMessagesSelector />}</div>
                    <div className='card-names'>Messages</div>
                </div>
                <DonutChart />
            </a>
        </div>       
    </>
  )
}

export default MainCard